import { defaultHelpMeNowQuestion, defaultProactiveSuggestionInterval, type TimelineFeatures } from "@expert/features";
import { env } from "./env";

export const envName = env.envName;
export const isProd = env.isProd;

export const timelineFeatures: TimelineFeatures = {
    helpMeNowQuestion: defaultHelpMeNowQuestion,
    isAutoCompleteEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
    isHelpMeNowEnabled: false,
    isOutageAlertInfoEnabled: false,
    isOzmoIFrameEnabled: false,
    isProactiveEnabled: false,
    isProactiveSuggestionEnabled: false,
    isReactiveCallContextEnabled: false,
    isReactiveCallContextV2Enabled: false,
    isSalesFAQEnabled: false,
    proactiveSuggestionInterval: defaultProactiveSuggestionInterval,
};
